import React, { useEffect, useState } from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import CollapseBox from './CollapseBox';
import Assignments from './Assignments';
import { Destination } from '../../utils/types/ProjectType';
import { mainColors } from '../../theme/themeConfig';

interface DestinationAssignmentsCollapseListProps {
  destinations: Destination[];
  projectEndDate: string;
  projectId: string;
  projectStartDate: string;
  projectStatus: string;
  refresh: () => void;
}

const DestinationAssignmentsCollapseList: React.FC<DestinationAssignmentsCollapseListProps> =
  function DestinationAssignmentsCollapseList({
    destinations,
    projectId,
    projectStatus,
    projectStartDate,
    projectEndDate,
    refresh
  }) {
    const [openDestination, setOpenDestination] = useState<{
      [destinationId: string]: boolean;
    }>({});

    useEffect(() => {
      if (destinations?.length > 0) {
        const firstDestinationId = String(destinations[0].id);
        setOpenDestination({ [firstDestinationId]: true });
      }
    }, [destinations]);

    const toggleDestination = (destinationId: string) => {
      setOpenDestination((prev) => {
        const isCurrentlyOpen = !!prev[destinationId];
        return { [destinationId]: !isCurrentlyOpen };
      });
    };

    return (
      <Box display="flex" flexDirection="column" gap={2}>
        {/* ── Assignments page header ── */}
        <Box
          sx={{
            alignItems: 'flex-start',
            display: 'flex',
            justifyContent: 'space-between',
            mb: 1
          }}
        >
          <Box>
            <Typography
              sx={{ color: '#0f1c2e', fontSize: '18px', fontWeight: 700 }}
            >
              Assignments
            </Typography>
            <Typography sx={{ color: '#7D8090', fontSize: '12px', mt: '2px' }}>
              Technician schedule ·{' '}
              {projectStartDate
                ? new Date(projectStartDate).toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'short'
                  })
                : ''}{' '}
              –{' '}
              {projectEndDate
                ? new Date(projectEndDate).toLocaleDateString('en-US', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric'
                  })
                : ''}
            </Typography>
          </Box>
          <Box
            sx={{
              alignItems: 'center',
              border: '1px solid #005DA2',
              '&:hover': { backgroundColor: '#EBF4FF' },
              borderRadius: '20px',
              color: '#005DA2',
              cursor: 'pointer',
              display: 'flex',
              fontSize: '12px',
              fontWeight: 600,
              gap: '6px',
              px: '14px',
              py: '7px',
              userSelect: 'none'
            }}
          >
            <Box sx={{ alignItems: 'center', display: 'flex', fontSize: 16 }}>
              ＋
            </Box>
            Assign Technician
          </Box>
        </Box>

        {destinations.map((destination) => (
          <CollapseBox
            destination={destination}
            isCollapseOpen={openDestination[destination.id]}
            key={destination.id}
            projectSetupTab="assignments"
            toggleDestination={() => toggleDestination(String(destination.id))}
          >
            <Collapse
              unmountOnExit
              in={!!openDestination[String(destination.id)]}
              timeout="auto"
            >
              <Box marginTop={1}>
                <Assignments
                  destinationId={destination.id}
                  id={projectId}
                  projectEndDate={projectEndDate}
                  projectStartDate={projectStartDate}
                  projectStatus={projectStatus}
                  refresh={refresh}
                />
              </Box>
            </Collapse>
          </CollapseBox>
        ))}
      </Box>
    );
  };

export default DestinationAssignmentsCollapseList;
